// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@bg/XDL/Utilities";
import { CustomerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import { css } from "styled-components";

export const customerAddressFormSharedStyle: CustomerAddressFormStyles = {
    formFields: {
        container: {
            gap: 16,
        },
        firstNameGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        lastNameGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        companyNameGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        attentionGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        countryGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        cityGridItem: {
            width: 12,
        },
        stateGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        postalCodeGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        phoneGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        faxGridItem: {
            width: [12, 6, 6, 6, 6],
            css: css`
                ${xScreen("lt", "sm")} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            `,
        },
        emailGridItem: {
            width: 12,
        },
    },
};
